








import { Component, Prop, Vue } from 'vue-property-decorator'
import SidebarItemLink from '@/layout/components/Sidebar/SidebarItemLink.vue';
import {RouteConfig} from 'vue-router';

@Component({
  name: 'SidebarButtonItem',
  components: {
    SidebarItemLink
  }
})
export default class extends Vue {
  @Prop({ required: true }) private text!: string
  @Prop({ required: true }) private icon!: string
  @Prop({ default: false }) private isCollapse!: boolean
  @Prop({ default: () => {} }) public onClick!: Function;

}
